import { LinearProgress, styled } from '@mui/material';
export default styled(LinearProgress)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 3,
}));
